<template>
  <!--
    A locked JobShop (JET-2155) renders only its password form: no layout, no
    page, so neither's setup runs and nothing protected is fetched, rendered or
    serialised. server/utils/passwordGate.ts decides; the status is already 403.
  -->
  <PasswordGate v-if="passwordGate" :error="passwordGate.error" />

  <!-- Otherwise exactly Nuxt's own default app component. -->
  <NuxtLayout v-else>
    <NuxtRouteAnnouncer />
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const passwordGate = usePasswordGate()
</script>
